import * as z from 'zod'

import { dateSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const attributeSchema = z.object({
  name: z.string(),
  hasOnlineRental: z.boolean().optional(),
  isInspectionsVisible: z.boolean().optional(),
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)

export type TaxiparkAttributes = z.infer<typeof attributeSchema>

export class Taxipark extends ApiModel<typeof schema, TaxiparkAttributes> {
  static jsonApiType = 'taxiparks'

  static schema = schema

  getName(): string {
    return this.getAttribute('name')
  }

  static async current(): Promise<Taxipark> {
    const response = await Taxipark.find('current')
    return response?.getData() as Taxipark
  }

  getOption(): { id: UniqueId; label: string } {
    return {
      id: this.getApiId() as UniqueId,
      label: this.getName(),
    }
  }

  static async fetchOptions(regionCode?: string) {
    let builder = Taxipark.limit(100)

    if (regionCode) {
      builder = builder.where('regionCode', regionCode)
    }

    const response = await builder.get(1)
    return response.getData().map((o) => o.getOption())
  }
}
